import formatCapitals from 'bam-node-baseball-savant/utils/format-capitals.ts'
import {
    Challenge,
    GamefeedRawData,
    IllustratorRawData,
    isGamefeedRawData,
} from '../../schema/types.ts'

function getNiceChallengeText(desc: string, challenge: Challenge) {
    const type = challenge.is_batter ? 'Batter' : 'Fielder'
    const decision = challenge.is_overturned ? 'overturned' : 'confirmed'
    return `
        <div>
            <em>${type} challenged, call ${decision}</em>
        </div>
        `
}
function getNiceDescription(desc: string, event_text: string) {
    switch (desc) {
        case '':
            return ''
        case 'swinging_strike_blocked':
            return 'Swinging Strike (Blocked)'
        case 'hit_into_play':
            return formatCapitals(event_text)
        default:
            // All other event types in the database can be handled just by the default capitalization handling
            return formatCapitals(desc)
    }
}

export default function SingleEventHtml(
    point: GamefeedRawData | IllustratorRawData,
    challenge?: Challenge
) {
    if (isGamefeedRawData(point)) {
        return getGamefeedHtml(point)
    }

    const niceDescription = getNiceDescription(point.description, point.events)
    const absDescription = challenge
        ? getNiceChallengeText(point.description, challenge)
        : ''
    const niceContactType = point.is_hit_into_play
        ? formatCapitals(point.stringer_hit_trajectory)
        : ''
    return `
    ${point.pitch_name ? `<div>${point.pitch_name}</div>` : ''}
    ${point.batter_name ? `<div>Batter: ${point.batter_name}</div>` : ''}
    ${point.pitcher_name ? `<div>Pitcher: ${point.pitcher_name}</div>` : ''}
    ${point.game_date ? `<div>Date: ${point.game_date}</div>` : ''}

    ${
        point.release_speed
            ? `<div>Pitch Speed: ${point.release_speed}</div>`
            : ''
    }
    ${
        point.launch_speed
            ? `<div>Exit Velocity: ${point.launch_speed}</div>`
            : ''
    }
    ${
        !point.launch_speed && point.h_launch_speed
            ? `<div>Exit Velocity: ${point.h_launch_speed}</div>`
            : ''
    }

    ${
        point.launch_angle
            ? `<div>Launch Angle: ${point.launch_angle}</div>`
            : ''
    }
    ${
        !point.launch_angle && point.h_launch_angle
            ? `<div>Launch Angle: ${point.h_launch_angle}</div>`
            : ''
    }

    ${point.inning != null ? `<div>Inning: ${point.inning}</div>` : ''}

    ${
        point.balls != null
            ? `<div>Count: ${point.balls}-${point.strikes}</div>`
            : ''
    }
    ${
        point.outs_when_up != null
            ? `<div>Outs: ${point.outs_when_up}</div>`
            : ''
    }

    ${niceDescription ? `<div>Result: ${niceDescription}</div>` : ''}
    ${absDescription}

    ${niceContactType ? `<div>Contact Type: ${niceContactType}</div>` : ''}
    `
}

// TODO: Outs is wrong
function getGamefeedHtml(pitch: GamefeedRawData) {
    const absDescription = pitch.abs_challenge
        ? getNiceChallengeText(pitch.description, pitch.abs_challenge)
        : ''

    const niceDescription = getNiceDescription(pitch.description, pitch.events)

    return `
    ${pitch.pitch_name ? `<div>${pitch.pitch_name}</div>` : ''}
    ${pitch.batter_name ? `<div>Batter: ${pitch.batter_name}</div>` : ''}
    ${pitch.pitcher_name ? `<div>Pitcher: ${pitch.pitcher_name}</div>` : ''}

    ${pitch.hit_speed ? `<div>Exit Velocity: ${pitch.hit_speed}</div>` : ''}

    ${pitch.hit_angle ? `<div>Launch Angle: ${pitch.hit_angle}</div>` : ''}

    ${pitch.start_speed ? `<div>Pitch Speed: ${pitch.start_speed}</div>` : ''}

    ${pitch.inning != null ? `<div>Inning: ${pitch.inning}</div>` : ''}

    ${
        pitch.balls != null
            ? `<div>Count: ${pitch.balls}-${pitch.strikes}</div>`
            : ''
    }
    ${pitch.outs != null ? `<div>Outs: ${pitch.outs}</div>` : ''}

    ${niceDescription ? `<div>Result: ${niceDescription}</div>` : ''}
    ${absDescription}
    `
}
